import { EClientPath } from '~/models/api'

/**
 * Routes that are accessible even when an organization has no assistants.
 * All other routes will show the FirstAssistantOnboarding page.
 */
export const ROUTES_ACCESSIBLE_WITHOUT_ASSISTANTS: EClientPath[] = [
  EClientPath.users,
  EClientPath.billing,
  EClientPath.account,
  EClientPath.manageAssistants,
  EClientPath.manageIntegrations,
  EClientPath.support,
  EClientPath.integrations,
  EClientPath.termsOfUse,
  EClientPath.privacyPolicy,
  EClientPath.referralsTerms,
  EClientPath.referralsInfo,
]

/**
 * Checks if a given pathname is accessible without assistants.
 * @param pathname - The current route pathname
 * @returns true if the route is accessible without assistants
 */
export const isRouteAccessibleWithoutAssistants = (
  pathname: string,
): boolean => {
  return ROUTES_ACCESSIBLE_WITHOUT_ASSISTANTS.some((route) =>
    pathname.includes(route),
  )
}
